import { z } from 'zod';

import { EmailWithUnicodeSchema } from '@vestigas/utils';

export const zodRejectionFileRoleSchema = z.enum([
  'raw_invoice_pdf',
  'processed_pdf',
  'parsing_input',
  'misc',
  'incoming_email',
  'outgoing_email',
  'invoice_check_protocol',
  'delivery_notes',
]);

const zodRejectInvoiceEmailSchema = z.object({
  cc: z.array(EmailWithUnicodeSchema),
  fileRoles: z.array(zodRejectionFileRoleSchema),
  message: z.string().trim().min(1),
  subject: z.string().trim().min(1),
  to: z.array(EmailWithUnicodeSchema).min(1),
  userFileIds: z.array(z.uuid()),
});

export const zodRejectInvoicePayloadSchema = z.object({
  comment: z.string().trim().min(1).nullish(),
  email: zodRejectInvoiceEmailSchema.nullish(),
});
